module.exports = __webpack_public_path__ + "img/pikabu-logo.ca4acc4e.svg";